
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function onError1(e) {
                    this.onImageError(e, 'image2');
                }
                return _createElement('div', { 'className': 'lg:px-8 px-6' + (window.document.body.classList.contains('template-product') ? ' productItem-container mb-16 w-full sm:w-1/2 md:w-2/6 lg:w-1/3 xl:w-1/4' : '') }, _createElement('div', { 'className': 'productItem relative' }, _createElement('div', { 'className': 'productItem__wrapper' }, _createElement('a', {
                    'href': this.url,
                    'className': 'productItem__imageWrapper block' + (!!this.image2 ? ' productItem__imageWrapper--withAlternateImage' : '')
                }, _createElement('div', { 'className': 'product__imageList' }, !!this.image2 ? _createElement('div', {
                    'className': 'productItem__Image productItem__Image--alternate image--fadeIn image--lazyLoaded aspectRatio aspectRatio--square',
                    'key': '485'
                }, _createElement('img', {
                    'src': this.resizeImage(this.image2),
                    'alt': this.removeHTML(this.title),
                    'loading': 'lazy',
                    'className': 'w-full',
                    'onError': onError1.bind(this)
                })) : null, _createElement('div', { 'className': 'object-cover productItem__image image--fadeIn image--lazyLoaded aspectRatio aspectRatio--square' }, _createElement('img', {
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'loading': 'lazy',
                    'className': 'w-full',
                    'onError': this.onImageError
                })), _createElement('span', { 'className': 'hover-arrow' }, _createElement('svg', {
                    'aria-hidden': 'true',
                    'className': 'icon icon--arrow-alt',
                    'viewBox': '0 0 16 16'
                }, _createElement('path', {
                    'd': 'M9.86719 10.0625L12.3984 7.53125L9.86719 5V7.09766H3V7.96484H9.86719V10.0625Z',
                    'fill': 'currentColor'
                }))))), _createElement('div', { 'className': 'productItem__info mt-12 text-left' }, _createElement('div', { 'className': 'productItem__title mb-5' }, _createElement('a', Object.assign({}, { 'href': this.url }, { dangerouslySetInnerHTML: { __html: this.title } }))), _createElement('div', { 'className': 'productItem__priceList tracking-normal text-right' }, _createElement('span', { 'className': 'productItem__price price text-9 color-blue' }, this.price_varies ? [
                    'From',
                    _createElement('br', { 'key': '18131' })
                ] : null, _createElement('span', { 'data-money-convertible': true }, this.formatPrice(this.price))))))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, 'You might also like...')), _createElement.apply(this, [
        'div',
        { 'className': 'productList productList--carousel carousel -mb-16 flex flex-wrap lg:justify-center cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []